import Phaser from "phaser";
import "./style.css";
import { createGameContext } from "./GameContext";
import { BootScene } from "./scenes/BootScene";
import { LoginScene } from "./scenes/LoginScene";
import { CharacterSelectScene } from "./scenes/CharacterSelectScene";
import { WorldScene } from "./scenes/WorldScene";

/**
 * Per 1.2: desktop browser first, 1280x720 minimum viewport, mobile
 * explicitly out of scope for v1.
 */
const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "app",
  width: 1280,
  height: 720,
  backgroundColor: "#0b0c14",
  dom: {
    // Required for LoginScene/CharacterSelectScene's this.add.dom(...) —
    // used for real text-input forms rather than bitmap-font input hacks.
    createContainer: true,
  },
  scene: [BootScene, LoginScene, CharacterSelectScene, WorldScene],
};

const game = new Phaser.Game(config);

// One GameContext per running client, shared across every Scene via the
// registry (see GameContext.ts's doc comment for why).
//
// FIXED: createGameContext() throws if VITE_API_BASE/VITE_ASSET_CDN aren't
// baked in at build time (env.ts's getEnv()). Previously that throw was
// completely silent from the player's perspective — game.registry.set(...)
// never ran, so ctx stayed permanently undefined on every Scene, and
// BootScene's `await controller.run()` threw trying to reach
// `ctx.assets`. Phaser doesn't surface a rejected async create() as a
// visible error, so the result was an indefinitely stuck "Loading..."
// screen with no on-screen indication anything was wrong — only a console
// error, easy to miss. This surfaces it directly on the page instead.
try {
  game.registry.set("ctx", createGameContext());
} catch (err) {
  const message = err instanceof Error ? err.message : String(err);
  console.error("[Aetheria] Failed to initialize game context:", err);
  const root = document.getElementById("app") ?? document.body;
  root.innerHTML = `<div style="font-family: sans-serif; color: #fff; background: #0b0c14; padding: 2rem; max-width: 640px;">
    <h2 style="color: #ff6b6b;">Failed to start</h2>
    <p>The game couldn't initialize: <code>${message}</code></p>
    <p style="opacity: 0.7; font-size: 0.9em;">This usually means a required build-time configuration value is missing. If you're a developer, check that VITE_API_BASE and VITE_ASSET_CDN are set before building.</p>
  </div>`;
}
